import React from "react";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import "./CardTurnoFiltro.css";

const CardTurnoFiltro = ({
  idTurno,
  medico,
  centro,
  ubicacion,
  coordenadaGps,
  hora,
  fecha,
  handleOnClickConfirmar,
  especialidad,
}) => {
  const boxCardEspecialidad = "ptur-cardTurnoFiltro-boxEsp";
  const btnEspecialidad = "ptur-cardTurnoFiltro-boxBtnEspecialidad";
  const medEspecialidad = "ptur-cardTurnosFiltro-box-bodyMedEsp";
  const idTerminal = getLocalStorage("idTerminal");

  return (
    <div
      className={`ptur-cardTurnoFiltro-box ${especialidad !== "" ? boxCardEspecialidad : ""
        }`}
    >
      <div
        className={`${medico !== ""
          ? "ptur-cardTurnosFiltro-box-body"
          : "ptur-cardTurnosFiltro-box-bodyLabo"
          }`}
      >
        <p
          className={`ptur-cardTurnosFiltro-box-bodyMed ${especialidad !== "" ? medEspecialidad : ""
            } rb16xl`}
        >
          {medico}
        </p>
        <p className="ptur-cardTurnosFiltro-box-bodyEsp rb16l">
          {especialidad}
        </p>

        <p className="ptur-cardTurnosFiltro-box-bodyCentro rb16xl">{centro}</p>
        <a
          href={!idTerminal && `https://maps.google.com/?q=${coordenadaGps}`}
          target="_blank"
          rel="noreferrer"
          className="ptur-cardTurnosFiltro-box-bodyUbi c-latex30 rb12tl"
        >
          {ubicacion}
        </a>
        <div className="ptur-cardTurnosFiltro-box-horaConfirmar">
          <p className="ptur-cardTurnosFiltro-box-bodyCentro rb16xl">
            {getDiaStrTurno(fecha, false, true)}
            {getDiaStrTurno(fecha, true, true)}
            <span className="ptur-cardTurnosFiltro-box-bodyHora rb16t">{`${hora}hs`}</span>
          </p>
          <div
            className={`ptur-cardTurnoFiltro-boxBtn ${especialidad !== "" ? btnEspecialidad : ""
              }`}
          >
            <button
              id={idTurno}
              onClick={() => handleOnClickConfirmar()}
              className="ptur-cardTurnoFiltro-btn bgc-primary c-white rb18m"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(CardTurnoFiltro, (prev, next) => {
  return (
    prev.idTurno === next.idTurno &&
    prev.medico === next.medico &&
    prev.centro === next.centro &&
    prev.ubicacion === next.ubicacion &&
    prev.coordenadaGps === next.coordenadaGps &&
    prev.hora === next.hora &&
    prev.fecha === next.fecha &&
    prev.especialidad === next.especialidad
  );
});
